import React from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Section from '../../../components/Section';
import { FormattedMessage } from 'react-intl';
import Text from '../../../components/Text';

function DataPolicyModal({ show, setShow }) {
  const handleClose = () => setShow(false);

  return (
    <>
      <Modal size="lg" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>
            <Text variant="documentHeaderTitle">
              <FormattedMessage defaultMessage="Datapolicy" />
            </Text>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Section>
            <Text variant="documentSectionTitle">
              <FormattedMessage defaultMessage="1. Introduktion" />
            </Text>

            <Text variant="documentSectionText" className="mt-1">
              <FormattedMessage
                defaultMessage="Välkommen till kthbok.com! Denna Datapolicy beskriver hur vi
              samlar in, använder, delar och skyddar dina personuppgifter när du
              besöker vår webbplats. Din integritet är viktig för oss, och vi
              åtar oss att skydda din information i enlighet med den allmänna
              dataskyddsförordningen (GDPR) och andra tillämpliga
              dataskyddslagar."
              />
            </Text>
          </Section>

          <Section>
            <Text variant="documentSectionTitle">
              <FormattedMessage defaultMessage="2. Dataansvarig" />
            </Text>
            <Text variant="documentSectionText" className="mt-1">
              <FormattedMessage defaultMessage="Markus Hilding" />
            </Text>
            <Text variant="documentSectionText" className="mt-1">
              <FormattedMessage defaultMessage="Becksjudarvägen 55, 131 36 Nacka" />
            </Text>
            <Text variant="documentSectionText" className="mt-1">
              <FormattedMessage defaultMessage="kontakt@kthbok.com" />
            </Text>
          </Section>

          <Section>
            <Text variant="documentSectionTitle">
              <FormattedMessage defaultMessage="3. Data vi samlar in" />
            </Text>
            <Text variant="documentSectionText" className="mt-1">
              <FormattedMessage defaultMessage="Kontaktinformation: Namn, e-postadress, telefonnummer, etc." />
            </Text>

            <Text variant="documentSectionText" className="mt-1">
              <FormattedMessage defaultMessage="Användningsinformation: IP-adress, webbläsartyp, operativsystem, besökta sidor, tid spenderad på webbplatsen, etc." />
            </Text>

            <Text variant="documentSectionText" className="mt-1">
              <FormattedMessage defaultMessage="Kakor och liknande teknologier: Vi använder cookies för att förbättra din webbläsarupplevelse. Du kan hantera dina cookie-inställningar genom din webbläsares inställningar." />
            </Text>
          </Section>

          <Section>
            <Text variant="documentSectionTitle">
              <FormattedMessage defaultMessage="4. Hur vi använder dina data" />
            </Text>
            <Text variant="documentSectionText" className="mt-1">
              <FormattedMessage defaultMessage="Vi använder dina personuppgifter för följande ändamål:" />
            </Text>
            <Text variant="documentSectionText" className="mt-1">
              <ul>
                <li>Att tillhandahålla och förbättra våra tjänster</li>
                <li>
                  Kommunikation med dig angående förfrågningar eller andra
                  önskemål
                </li>
                <li>
                  Skicka marknadsföringsmaterial och kampanjer (med ditt
                  samtycke)
                </li>
                <li>
                  Analysera webbplatsanvändningen för att förbättra
                  användarupplevelsen
                </li>
                <li>Uppfylla lagliga skyldigheter</li>
              </ul>
            </Text>
          </Section>

          <Section>
            <Text variant="documentSectionTitle">
              <FormattedMessage defaultMessage="5. Rättslig grund för databehandling" />
            </Text>
            <Text variant="documentSectionText" className="mt-1">
              <FormattedMessage defaultMessage="Vi behandlar dina personuppgifter baserat på:" />
            </Text>
            <Text variant="documentSectionText" className="mt-1">
              <ul>
                <li>Ditt samtycke</li>
                <li>Avtal</li>
              </ul>
            </Text>
          </Section>

          <Section>
            <Text variant="documentSectionTitle">
              <FormattedMessage defaultMessage="6. Delning och avslöjande av data" />
            </Text>
            <Text variant="documentSectionText" className="mt-1">
              <FormattedMessage defaultMessage="Vi kan dela dina personuppgifter med:" />
            </Text>

            <Text variant="documentSectionText" className="mt-1">
              <ul>
                <li>
                  Tjänsteleverantörer och affärspartners som hjälper oss att
                  driva webbplatsen och tillhandahålla tjänster
                </li>
                <li>
                  Lagliga och reglerande myndigheter när det krävs enligt lag
                </li>
                <li>Tredje parter med ditt samtycke</li>
              </ul>
            </Text>
          </Section>

          <Section>
            <Text variant="documentSectionTitle">
              <FormattedMessage defaultMessage="7. Internationella datatransfer" />
            </Text>
            <Text variant="documentSectionText" className="mt-1">
              <FormattedMessage
                defaultMessage=" Om vi överför dina data till länder utanför Europeiska ekonomiska
              samarbetsområdet (EES), kommer vi att se till att lämpliga
              skyddsåtgärder finns på plats för att skydda dina data enligt
              GDPR."
              />
            </Text>
          </Section>

          <Section>
            <Text variant="documentSectionTitle">
              <FormattedMessage defaultMessage="8. Dataskyddsperiod" />
            </Text>
            <Text variant="documentSectionText" className="mt-1">
              <FormattedMessage
                defaultMessage="Vi kommer att behålla dina personuppgifter endast så länge som det
                är nödvändigt för att uppfylla de ändamål som anges i denna policy
                eller enligt lagens krav."
              />
            </Text>
          </Section>

          <Section>
            <Text variant="documentSectionTitle">
              <FormattedMessage defaultMessage="9. Dina rättigheter" />
            </Text>
            <Text variant="documentSectionText" className="mt-1">
              <FormattedMessage defaultMessage="Du har rätt att:" />
            </Text>

            <Text variant="documentSectionText" className="mt-1">
              <ul style={{ marginBottom: 0 }}>
                <li>Få tillgång till de personuppgifter vi har om dig</li>
                <li>Rätta eventuella felaktigheter i dina personuppgifter</li>
                <li>Återkalla ditt samtycke när som helst (om tillämpligt)</li>
                <li>Radera dina personuppgifter</li>
                <li>Protestera mot eller begränsa behandling</li>
                <li>
                  Ta emot en kopia av dina data i ett allmänt användbart
                  elektroniskt format
                </li>
              </ul>
            </Text>
          </Section>

          <Section>
            <Text variant="documentSectionTitle">
              <FormattedMessage defaultMessage="10. Säkerhet" />
            </Text>
            <Text variant="documentSectionText" className="mt-1">
              <FormattedMessage
                defaultMessage="Vi implementerar rimliga säkerhetsåtgärder för att skydda dina
                personuppgifter från obehörig åtkomst, avslöjande, ändring eller
                förstörelse."
              />
            </Text>
          </Section>

          <Section>
            <Text variant="documentSectionTitle">
              <FormattedMessage defaultMessage="11. Kontakta oss" />
            </Text>
            <Text variant="documentSectionText" className="mt-1">
              <FormattedMessage
                defaultMessage="Om du har några frågor eller funderingar angående denna Datapolicy
                eller dina personuppgifter, vänligen kontakta oss på
                kontakt@kthbok.com"
              />
            </Text>
          </Section>

          <Section>
            <Text variant="documentSectionTitle">
              <FormattedMessage defaultMessage="12. Uppdateringar av denna policy" />
            </Text>
            <Text variant="documentSectionText" className="mt-1">
              <FormattedMessage
                defaultMessage="Vi kan uppdatera denna Datapolicy för att återspegla förändringar
                i våra praxis eller rättsliga krav. Alla uppdateringar kommer att
                publiceras på denna sida."
              />
            </Text>
          </Section>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleClose}>Stäng</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default DataPolicyModal;
